// BOOTSTRAP //
jQuery(document).ready(function(jQuery){
	$(".single-option-selector").css("width","100%");
	$('.typeahead').typeahead();
	$('.dropdown-toggle').dropdown();
	$('.carousel').carousel({
		interval: 10000
	})
});

// PLACEHOLDER POLYFILL //
$(document).ready(function(){
	function add() {
		if($(this).val() == ''){
			$(this).val($(this).attr('placeholder')).addClass('placeholder');
		};
	};

	function remove() {
		if($(this).val() == $(this).attr('placeholder')){
			$(this).val('').removeClass('placeholder');
		};
	};

	// Create a dummy element for feature detection
	if (!('placeholder' in $('<input>')[0])) {

		// Select the elements that have a placeholder attribute
		$('input[placeholder], textarea[placeholder]').blur(add).focus(remove).each(add);

		// Remove the placeholder text before the form is submitted
		$('form').submit(function(){
			$(this).find('input[placeholder], textarea[placeholder]').each(remove);
		});
	};
  	
});
     
// CURRENCY SELECTOR //
$('.selected-currency a').click(function() {
	$('.selected-currency a').hide();
	$('#currencies-picker').fadeIn();
	return false;
});
$('#currencies-picker select').change(function() {
	$('#currencies-picker').hide();
	$('.selected-currency a').fadeIn();
	return true;
}).blur(function() {
	$('#currencies-picker').hide();
	$('.selected-currency a').fadeIn();
	return true;
});


// GIFT WRAP //
$('#gift-checkbox').on('click', function(){
  var is_gift = $(this).attr('checked') == 'checked' ? true : false;
  if (is_gift) {
    $('.gift-wrap-checkbox').removeClass('hidden');
  }else{
    $('.gift-wrap-checkbox').addClass('hidden');
    $.post('/cart/update.js', {
      updates: {
        "38641816842":0
      }
    }).done(function(data){
      console.log(data);
    });    
  }  
});

$('#gift-wrap-checkbox').on('click', function(){
  var is_gift = $(this).attr('checked') == 'checked' ? true : false;
  if (is_gift) {
    $.post('/cart/update.js', {
      updates: {
        "38641816842":1
      }      
    }).done(function(data){
      console.log(data);
    });
  }else{
    $.post('/cart/update.js', {
      updates: {
        "38641816842":0
      }
    }).done(function(data){
      console.log(data);
    });
  }  
});

/*
 This seems odd but it fixes the issue with FancyBox
*/

$("a.fancybox").click(function(e){e.preventDefault()});


/* Track outbound links in Google Analytics */
(function($) {

  "use strict";

  // current page host
  var baseURI = window.location.host;

  // click event on body
  $("body").on("click", function(e) {

    // abandon if link already aborted or analytics is not available
    if (e.isDefaultPrevented() || typeof ga !== "function") return;

    // abandon if no active link or link within domain
    var link = $(e.target).closest("a");
    if (link.length != 1 || baseURI == link[0].host) return;

    // cancel event and record outbound link
    e.preventDefault();
    var href = link[0].href;
    ga('send', {
      'hitType': 'event',
      'eventCategory': 'outbound',
      'eventAction': 'link',
      'eventLabel': href,
      'hitCallback': loadPage
    });

    // redirect after one second if recording takes too long
    setTimeout(loadPage, 1000);

    // redirect to outbound page
    function loadPage() {
      document.location = href;
    }

  });

})(jQuery); // pass another library here if required
